import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .controller('PlatformSettingsCtrl', PlatformSettingsCtrl);

    function PlatformSettingsCtrl(
        $routeParams,
        platformSettingsService,
        $location
    ) {
        var vm = this;

        vm.isActive = function isActive(path: string, exact?: boolean) {
            if (exact) return $location.path() === path;
            else return $location.path().startsWith(path);
        };

        if (angular.isUndefined($routeParams.page)) {
            vm.page = platformSettingsService.startPage;
        } else {
            vm.page = platformSettingsService.pages[$routeParams.page];
        }
    }
})();
